import React from 'react';
import NotificationPrefs from './NotificationPrefs';
import DataSaverPrefs from './DataSaverPrefs';
import { NdoePage, NdoePageHeader } from '../../components/ndoe';

// Page autonome des préférences de notification — routée pour TOUS les rôles
// (staff ET livreur). Le lien « Paramètres » de la cloche menait à /profile,
// inexistant dans le routeur livreur → redirection silencieuse vers le hub
// sans aucun moyen de couper les alertes (constat revue #98).
const PagePrefsNotifications = () => (
  <NdoePage>
    <NdoePageHeader
      eyebrow="Paramètres"
      title="Mes préférences"
      subtitle="Alertes de cet appareil et consommation de données."
    />
    <NotificationPrefs />
    {/* Économie de données (16/07) : monté ici ET dans Profile — les deux
        routes existent déjà pour le staff ET pour le livreur. */}
    <DataSaverPrefs />
  </NdoePage>
);

export default PagePrefsNotifications;
